import { Point } from "pixi.js";
import { MessageBarLandscapeProperties } from "../landscape/MessageBarLandscapeProperties";
/**
 * MessageBarPortraitProperties.ts
 */
export class MessageBarPortraitProperties extends MessageBarLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position = new Point(512, 0);
        this.gameIdProperties.position = new Point(50, 0);
        this.gameIdProperties.size = new Point(300, 50);
        this.clockProperties.position = new Point(1230, -6);
        this.messageFieldProperties.position.set(512, -6);
    }
}
